module.exports = __webpack_public_path__ + "img/list_6.5bf59113.png";